<span *ngIf="isEnabled" >
	<div *ngIf="currentTutorialIndex== 0" class="tutorial-container" (click)="onTapTutorial()">
		<div class="tutorial-shadow"></div>
		<div class="tutorial-image tut1"></div>
	</div>
	<div *ngIf="currentTutorialIndex == 1" class="tutorial-container" (click)="onTapTutorial()">
		<div class="tutorial-shadow"></div>
		<div class="tutorial-image tut2"></div>
	</div>
	<div *ngIf="currentTutorialIndex == 2" class="tutorial-container" (click)="onTapTutorial()">
		<div class="tutorial-shadow"></div>
		<div class="tutorial-image tut3"></div>
	</div>
	<div *ngIf="currentTutorialIndex == 3" class="tutorial-container" (click)="onTapTutorial()">
		<div class="tutorial-shadow"></div>
		<div class="tutorial-image tut4"></div>
	</div>
	<div *ngIf="currentTutorialIndex == 4" class="tutorial-container" (click)="onTapTutorial()">
		<div class="tutorial-shadow"></div>
		<div class="tutorial-image tut5"></div>
	</div>
</span>